import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from "reselect";
import { apiCallBegan } from "./api";

const slice = createSlice({
  name: "policyStatus",
  initialState: {
    statusDeatils: {},
  },
  reducers: {
    gettingStatus: (policyStatus, action) => {
      policyStatus.statusDeatils = {};
    },
    getAllStatus: (policyStatus, action) => {
      policyStatus.statusDeatils = action.payload;
    },
    gettingStatusFailed: (policyStatus, action) => {
      policyStatus.statusDeatils = {};
    },
  },
});
export const { gettingStatus, getAllStatus, gettingStatusFailed } =
  slice.actions;

export default slice.reducer;

export const getStatusApi = () =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/policies/policy-status",
    method: "get",
    onStart: gettingStatus.type,
    onSuccess: getAllStatus.type,
    onError: gettingStatusFailed.type,
  });
export const createPolicyApi = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/policies/create",
    method: "post",
    data: data,
  });
export const updatePolicyStatusApi = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/policies/update-status",
    method: "post",
    data: data,
  });

export const addAdditionalInsurers = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/policies/add-update-additional-insurers",
    method: "post",
    data: data,
  });

export const deleteAdditionalInsurers = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/policies/delete-additional-insurers",
    method: "delete",
    data: data,
  });

export const getPolicyStatusData = createSelector(
  (state) => state.entities.policyStatus,
  (policyStatus) => policyStatus.statusDeatils
);
